<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" v-bind="disabledValue" :show-tag="true" @on-click="onClick" />
	<pc-upload
		v-show="!(disabled && showDisabledText)"
		ref="uploadRef"
		v-model="value"
		:limit="maxUpLength"
		:file-size="maxSize"
		:file-type="fileType"
		:is-show-tip="showTip"
		:disabled="disabled"
		v-bind="$attrs"
		style="width: 100%"
	/>
</template>

<script setup lang="ts">
	import { downloadByUrl } from '@power/runtime-vue3';
	import DisabledText from './disabledText.vue';
	import { PcUpload } from '@/components';

	interface Props {
		modelValue: string;
		disabled?: boolean;
		showDisabledText?: boolean;
		accept?: string;
		maxUpLength?: number;
		maxSize?: number;
		showTip?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const isV1Ver = 'V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION;

	const uploadRef = ref<InstanceType<typeof PcUpload>>();

	const fileType = computed(() => (props.accept ? props.accept.split(',') : []));

	const value = computed({
		get() {
			return Array.isArray(props.modelValue) ? props.modelValue : props.modelValue ? props.modelValue?.split(',') : [];
		},
		set(value) {
			emit('update:modelValue', value.join(','));
		},
	});

	const disabledValue = computed(() => {
		const fieldList: any = uploadRef.value?.fileList || [];
		return {
			value: fieldList.map((i) => i.id),
			params: fieldList.map((i) => ({
				label: i.name,
				value: i.id,
				url: i.url,
			})),
		};
	});

	const onClick = (row) => {
		let url = '';
		if (isV1Ver) {
			url = row.url;
		} else {
			url = `${window.location.origin}${row.url}`;
		}
		downloadByUrl({ url, fileName: row.label });
	};
</script>

<style scoped></style>
